import React, { useContext, useEffect, useState } from "react";
import Navbar from "../../Components/Navbar";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Col, Container, Modal, Row, Tab, Table, Tabs } from "react-bootstrap";
import api from "../../Components/Api/Api";
import "./index.scss";

import MUIDataTable from "mui-datatables";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import { HiOutlineXMark } from "react-icons/hi2";
import { BsCashCoin } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "../../Components/Spinner";
import Configjson from "../../Components/Configuracao/config.json";
import { UserContext } from "../../context/UserContext";
import { Console } from "console";
import { Checkbox } from "@mui/material";

const muiCache = createCache({
  key: "mui-datatables",
  prepend: true,
});

const Editarentrada = () => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const orcamento = location.state;
  const navigate = useNavigate();
  const [placa, setPlaca] = useState("");
  const [cgc, setCGC] = useState("");
  const [codigo, setCodigo] = useState("");
  const [loja, setLoja] = useState("");
  const [nome, setNome] = useState("");
  const [infoveiculo, setInfoveuculo] = useState("");
  const [showmodal, setShowmodal] = useState(false);
  const [ShowLoading, setShowLoading] = useState(false);
  const [ShowPrcprazo, setShowPrcprazo] = useState(false);
  const [ShowBuscaclientes, setShowBuscaclientes] = useState(false);
  let [_pro, set_Pro] = useState<any>([]);
  let [precoprazo, setPrecoprazo] = useState<any>([]);
  let [condpag, setCondpag] = useState<any>([]);
  let [index, setIndex] = useState(0);
  const [p1, setP1] = useState([0]);
  const [p2, setP2] = useState([0]);
  const [obs, setObs] = useState("");
  const vendedor = user.codigo;
  const [idp1, setIdp1] = useState("");
  const [idp2, setIdp2] = useState("");
  const [buscaprod, setBuscaprod] = useState("");
  const [estoque, setEstoque] = useState("3");
  let [clientes, setClientes] = useState<any>([]);
  const [consultacliente, setConsultacliente] = useState("");
  let [vldesconto, setVldesconto] = useState<number>(0);
  let [pdesconto, setPdesconto] = useState<number>(0);
  let [vltotal, setvltotal] = useState(0);
  let [formapag, setFormapag] = useState("R$");
  let [codcond, setCodcond] = useState("");
  let [quantparcel, setQuantparcel] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [getorcamento, setGetOrcamento] = useState(true);
  const credentials = btoa(`${user.userRest}:${user.passRest}`); 
  const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      "Access-Control-Allow-Origin": "*",
      "User-Agent": "PneusBrasil",
      "Accept": "application/json",
      'Authorization': `Basic ${credentials}`
    } 
  interface Itens {
    id: number;
    produto: string;
    prodescricao: string;
    quantidade: number;
    preco: number;
    pco_venda: number;
    pco_avista: number;
    promocao: number;
  }
  //const itens: Itens[] = [];
  const gerOrcamento = () => {
    api
      .get("EditarOrcamento?filial=" + user.filial + "&consulta=" + orcamento,{headers})
      .then((response) => {
        if (response.data.Orcamento.length > 0) {
          if (getorcamento) {
            setGetOrcamento(false);
            setCodigo(response.data.Orcamento[0]["codigo"]);
            setLoja(response.data.Orcamento[0]["loja"]);
            setNome(response.data.Orcamento[0]["nome"]);
            setIdp1(response.data.Orcamento[0]["p1"]);
            setIdp2(response.data.Orcamento[0]["p2"]);
            setPlaca(response.data.Orcamento[0]["placa"]);
            setObs(response.data.Orcamento[0]["obs"]);
            setCodcond(response.data.Orcamento[0]["condpag"]);
            setFormapag(response.data.Orcamento[0]["formpag"]);
            setQuantparcel(response.data.Orcamento[0]["parcel"]);
            setInfoveuculo("Placa: " + response.data.Orcamento[0]["placa"]); //+ ' Modelo: ' + response.data.Dadoscliente[0]['modelo'] + ' Cor: ' + response.data.Dadoscliente[0]['cor'])
            if (_pro.length < response.data.Orcamento.length) {
              for (let i = 0; i < response.data.Orcamento.length; i++) {
                //itens.push({ id: Number(response.data.Orcamento[i]['id']), produto: response.data.Orcamento[i]['produto'], prodescricao: response.data.Orcamento[i]['descricao'], quantidade: response.data.Orcamento[i]['quantidade'], pco_venda: response.data.Orcamento[i]['vlunitario'] }); pco_venda: data[rowsSelected[i]]['pco_venda'],pco_avista: data[rowsSelected[i]]['pco_avista'], promocao: data[rowsSelected[i]]['promocao']
                _pro.push({
                  id: Number(response.data.Orcamento[i]["id"]),
                  produto: response.data.Orcamento[i]["produto"],
                  prodescricao: response.data.Orcamento[i]["descricao"],
                  quantidade: response.data.Orcamento[i]["quantidade"],
                  preco: response.data.Orcamento[i]["vlunitario"],
                  pco_venda: response.data.Orcamento[i]["vlunitario"],
                  pco_avista: 0,
                  promocao: 0,
                  autoriza: response.data.Orcamento[i]["autoriza"],
                });
              }
            }
            set_Pro(_pro);
          }
        } else {
          setCodigo("Cliente não cadastrado!");
          setLoja("");
          setNome("");
          setPlaca("");
          setInfoveuculo("Placa não cadastrada!");
        }
      });
  };
  const getplaca = () => {
    if (placa !== "") {
      api
        .get("Dadosveiculo?filial=" + user.filial + "&consulta=" + placa,{headers})
        .then((response) => {
          if (response.data.Dadosveiculo.length > 0) {
            if (codigo === "") {
              setCodigo(response.data.Dadosveiculo[0]["codigo"]);
              setLoja(response.data.Dadosveiculo[0]["loja"]);
              setNome(response.data.Dadosveiculo[0]["nome"]);
              setCGC(response.data.Dadosveiculo[0]["cgc"]);
            }
            setInfoveuculo(
              "Placa: " +
                placa +
                " Modelo: " +
                response.data.Dadosveiculo[0]["modelo"] +
                " Cor: " +
                response.data.Dadosveiculo[0]["cor"]
            );
          } else {
            setInfoveuculo("Placa não cadastrada!");
          }
        });
    }
  };
  const handlingplaca = (e: any) => {
    setPlaca(e.target.value.toUpperCase());
    console.log(e.target.value.toUpperCase());
  };
  const Apigetcliente = (nTp: number) => {
    if (consultacliente !== "") {
      api
        .get(
          "Dadoscliente?filial=" +
            user.filial +
            "&consulta=" +
            consultacliente +
            "&tpconsulta=" +
            nTp,{headers}
        )
        .then((response) => {
          if (response.data.Dadoscliente.length > 0) {
            if (nTp === 1) {
              setCodigo(response.data.Dadoscliente[0]["codigo"]);
              setLoja(response.data.Dadoscliente[0]["loja"]);
              setNome(response.data.Dadoscliente[0]["nome"]);
              setCGC(response.data.Dadoscliente[0]["cgc"]);
            } else {
              setClientes(response.data.Dadoscliente);
              setConsultacliente("");
            }

            if (placa === "") {
              setPlaca(response.data.Dadoscliente[0]["placa"]);
              setInfoveuculo(
                "Placa: " +
                  response.data.Dadoscliente[0]["placa"] +
                  " Modelo: " +
                  response.data.Dadoscliente[0]["modelo"] +
                  " Cor: " +
                  response.data.Dadoscliente[0]["cor"]
              );
            }
          } else {
            setCodigo("Cliente não cadastrado!");
            setLoja("");
            setNome("");
            setPlaca("");
            setInfoveuculo("Placa não cadastrada!");
          }
        });
    }
  };
  const getBuscacliente = (
    cpf: string,
    codigo: string,
    loja: string,
    nome: string
  ) => {
    setCGC(cpf);
    setCodigo(codigo);
    setLoja(loja);
    setNome(nome);
    setShowBuscaclientes(false);
  };
  useEffect(() => {
    if (condpag.length === 0) {
      getcondpag();
    }
    const el = document.querySelectorAll("div[id=divmodal]");
    const e = document.querySelectorAll("div[id=divprcprazo]");
    const cli = document.querySelectorAll("div[id=divclientes]");
    if (showmodal === true) {
      el[0].setAttribute("style", "display:block");
    } else {
      el[0].setAttribute("style", "display:none");
    }
    if (ShowPrcprazo === true) {
      e[0].setAttribute("style", "display:block");
    } else {
      e[0].setAttribute("style", "display:none");
    }
    if (ShowBuscaclientes === true) {
      e[0].setAttribute("style", "display:block");
    } else {
      e[0].setAttribute("style", "display:none");
    }
    if (p1.length === 1) {
      let p_1 = [0];
      for (let i = 1; i <= Configjson.data[0].P1; i++) {
        p_1.push(i);
      }
      setP1(p_1);
    }
    if (p2.length === 1) {
      let p_2 = [0];
      for (let i = 1; i <= Configjson.data[0].P2; i++) {
        p_2.push(i);
      }
      setP2(p_2);
    }
    if (getorcamento) {
      gerOrcamento();
    }
  }, [location.key]);
  //Busca produtos inicio
  const columns = [
    {
      name: "produto",
      width: "10%",
      options: { filterOptions: { fullWidth: true } },
    },
    "descricao",
    //"pco_venda",
    {
      name: "pco_venda",
      options: {
        filter: true,
        customBodyRender: (value: any) => {
          const nf = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

          return nf.format(value);
        },
      },
    },
    //"pco_avista",
    {
      name: "pco_avista",
      options: {
        filter: true,
        customBodyRender: (value: any) => {
          const nf = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

          return nf.format(value);
        },
      },
    },
    //"promocao",
    {
      name: "promocao",
      options: {
        filter: true,
        customBodyRender: (value: any) => {
          const nf = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

          return nf.format(value);
        },
      },
    },
    "estoque",
    "empresa",
  ];
  const [rowsSelected, setrowsSelected] = useState([]);
  const options = {
    textLabels: {
      body: {
        noMatch: "",
      },
    },
    search: true,
    viewColumns: true,
    filter: true,
    download: false,
    print: false,
    reponsive: "simple",
    tableBodyHeight: "400px",
    rowsSelected: rowsSelected,
    selectableRowsHeader: false,
    onTableChange: (action: any, state: any) => {},
    onRowSelectionChange: (
      rowsSelectedData: any,
      allRows: any,
      rowsSelected: any
    ) => {
      setrowsSelected(rowsSelected);
      for (let i = 0; i < rowsSelected.length; i++) {
        _pro.push({
          id: i,
          produto: data[rowsSelected[i]]["produto"],
          prodescricao: data[rowsSelected[i]]["descricao"],
          quantidade: 0,
          preco: data[rowsSelected[i]]["pco_venda"],
          pco_venda: data[rowsSelected[i]]["pco_venda"],
          pco_avista: data[rowsSelected[i]]["pco_avista"],
          promocao: data[rowsSelected[i]]["promocao"],
        });
        //_pro.push(itens)
      }
    },
    // onCellClick: (colData: any, cellMeta: { colIndex: number, rowIndex: number, dataIndex: number }) => {
    //     console.log(cellMeta)
    // },
    isRowSelectable: (dataIndex: any, selectedRows: any) => {
      if (
        selectedRows.data.length > 0 &&
        selectedRows.data.filter((d: any) => d.dataIndex === dataIndex)
          .length === 0
      )
        return false;
      //prevents selection of row with title "Attorney"
      return data[dataIndex][1] !== "000000";
    },
  };
  const [data, setData] = useState([]);

  const getbusca = (e: string) => {
    api
      .get(
        "Dadosprodutos?consulta=" +
          e +
          "&estoque=" +
          estoque +
          "&filial_=" +
          user.filial,{headers}
      )
      .then((response) => {
        if (response.data.Dadosprodutos.length > 0) {
          setData(response.data.Dadosprodutos);
        } else {
          setData([]);
        }
      });
  };
  const uppprod = (e: any) => {
    setBuscaprod(e.target.value.toUpperCase());
  };
  const upcliente = (e: any) => {
    setConsultacliente(e.target.value.toUpperCase());
  };
  const handlingincluir = () => {
    setShowmodal(false);
    setrowsSelected([]);
    //setData([])
  };
  const handlingexcluir = (e: any, index: any) => {
    let it = [..._pro];
    let answer = window.confirm("Deseja realmente excluir esse item?");
    //const el = document.querySelectorAll('tr');
    if (answer) {
      //el[index+1].setAttribute('style', 'visibility: hidden;');
      it.splice(index, 1);
      set_Pro(it);
      console.log("Item excluido!.");
    } else {
      console.log("item não excluido!");
    }
  };
  const handlinprcprazo = (e: any, index: any, prod: string) => {
    api.get("Precoprazo?consulta=" + prod,{headers}).then((response) => {
      if (response.data.Precosprodutos.length > 0) {
        setIndex(index);
        setPrecoprazo(response.data.Precosprodutos);
        setShowPrcprazo(true);
      }
    });
  };
  const getcondpag = () => {
    api.get("Condpag?filial=" + user.filial,{headers}).then((response) => {
      if (response.data.Condpag.length > 0) {
        setCondpag(response.data.Condpag);
      }
    });
  };
  const selectprecoprazo = (preco: number) => {
    let it = [..._pro];
    let answer = window.confirm("Deseja realmente selecionar esse preço?");
    if (answer) {
      //el[index+1].setAttribute('style', 'visibility: hidden;');
      it[index].preco = preco;
      set_Pro(it);
      setShowPrcprazo(false);
    }
  };
  const geraorcamento = () => {
    if (_pro.length === 0) {
      setShowLoading(false);
      return alert("falta produtos no orçamento!");
    }
    if (codigo === "") {
      setShowLoading(false);
      return alert("Por favor, selecionar um cliente!");
    }
    if (placa === "") {
      setShowLoading(false);
      return alert("Por favor, informar a palca do veiculo!");
    }

    const url = "Pedidoloja";
    // const headers2 = {
    //   "Content-Type": "application/json;charset=UTF-8",
    //   "Access-Control-Allow-Origin": "*",
    //   "User-Agente": "PneusBrasil",
    //   Accept: "*/*",
    //   'Authorization': `Basic ${credentials}`,
    // };
    let payload = "";
    payload += "{";
    payload += '"nOpx": 4,';
    payload += '"LQ_FILIAL": "' + user.filial + '",';
    payload += '"LQ_NUM": "' + orcamento + '",';
    payload += '"LQ_CLIENTE": "' + codigo + '",';
    payload += '"LQ_LOJA": "' + loja + '",';
    payload += '"LQ_PLACAVE": "' + placa + '",';
    payload += '"LQ_OBS": "' + obs + '",';
    payload += '"LQ_P1": "' + idp1.substring(2) + '",';
    payload += '"LQ_P2": "' + idp2.substring(2) + '",';
    payload += '"LQ_DESCONT": ' + vldesconto + ",";
    payload += '"LQ_DESCNF": ' + pdesconto + ",";
    if (codcond !== "" && codcond !== "CN ") {
      for (let i = 0; i < condpag.length; i++) {
        if (codcond === condpag[i].codigo) {
          setFormapag(condpag[i].forma);
          setQuantparcel(condpag[i].quantparcel);
        }
      }
      payload += '"LQ_CONDPG": "' + codcond + '",';
      payload += '"LQ_FORMPAG": "' + formapag + '",';
      payload += '"LQ_PARCELA": ' + quantparcel + ",";
    }
    payload += '"Items": [';
    for (let i = 0; i < _pro.length; i++) {
      if (_pro[i]["quantidade"] === 0) {
        setShowLoading(false);
        return alert(
          "Por favor preencher a quantidade do produto! " + _pro[i]["produto"]
        );
      }
      if (_pro[i]["preco"] === "0") {
        setShowLoading(false);
        return alert(
          "Por favor preencher o preço do produto! " + _pro[i]["produto"]
        );
      }
      payload += "{";
      payload += '"LR_FILIAL": "' + user.filial + '",';
      payload += '"LR_PRODUTO": "' + _pro[i]["produto"] + '",';
      payload += '"LR_ITEM": "' + addZeroes(i + 1, 2) + '",';
      payload += '"LR_DESCRI": "' + _pro[i]["prodescricao"] + '",';
      payload += '"LR_QUANT": ' + _pro[i]["quantidade"] + ",";
      payload += '"LR_PRCTAB": ' + _pro[i]["preco"] + ",";
      payload += '"LR_VRUNIT": ' + _pro[i]["preco"] + ",";
      let prtotal = _pro[i]["quantidade"] * _pro[i]["preco"];
      payload += '"LR_VLRITEM": ' + prtotal + ",";
      payload += '"LR_PRTABD": ' + _pro[i]["preco"] + ",";
      payload += '"LR_LOCAL":"01",';
      payload += '"LR_XAPROVA": "A",';
      payload += '"LR_ENTREGA":"2"';

      if (_pro.length > 1) {
        if (i + 1 < _pro.length) {
          payload += "},";
        }
      }
    }
    payload += "}";
    payload += "],";
    payload += '"Parcelas": [';
    payload += "{";
    payload += '"L4_DATA": "31/07/2024",';
    payload += '"L4_VALOR": ' + vltotal + ",";
    //payload += '"L4_VALOR": 2863,';
    payload += '"L4_FORMA": "' + formapag + '"';
    payload += "}";
    payload += "]";
    payload += "}";
    const data = payload;
    console.log(payload);
    api.post(url, data,{headers})
      .then(function (response) {
        if (response.data["info"] === "Erro") {
          alert("Erro, numero: " + response.data["codigo"]);
          console.log("Erro, numero: ", response.data["codigo"]);
          setShowLoading(false);
        }
        if (response.data["info"] === "criado") {
          alert("Orçamento alterado, numero: " + response.data["codigo"]);
          console.log("Orçamento alterado, numero: ", response.data["codigo"]);
          navigate("/novaentrada");
          set_Pro([]);
          setvltotal(0);
          setVldesconto(0);
          setPdesconto(0);
          setShowLoading(false);
        }
      })
      .catch(function (error) {
        console.error(error);
        alert(error);
        setShowLoading(false);
      });
  };
  const modalclose = () => {
    setShowmodal(false);
    setData([]);
    setrowsSelected([]);
  };
  const changeobs = (e: any) => {
    setObs(e.target.value.toUpperCase());
  };
  const chageselectmecanico = (e: any) => {
    if (e.target.value !== "P10") {
      setIdp1(e.target.value);
    }
  };
  const chageselectalinhamento = (e: any) => {
    if (e.target.value !== "P20") {
      setIdp2(e.target.value);
    }
  };
  const chageselectaformpag = (e: any) => {
    setFormapag(e.target.value);
  };
  const changeItems = (e: any, index: any) => {
    let it = [..._pro];
    if (parseInt(e.target.value) > 0) {
      it[index].quantidade = parseInt(e.target.value);
    } else {
      it[index].quantidade = 0;
    }
    set_Pro(it);
    setPdesconto(0);
    setVldesconto(0);
    AtualizaTotal(0);
  };
  const chageselectcondpag = (e: any) => {
    setCodcond(e.target.value);
  };
  const chageselectpreco = (e: any, index: any) => {
    let it = [..._pro];
    it[index].preco = e.target.value;
    set_Pro(it);
    setPdesconto(0);
    setVldesconto(0);
    AtualizaTotal(0);
  };
  const chageselectestoque = (e: any) => {
    if (e.target.value !== "") {
      setEstoque(e.target.value);
    }
  };
  const AtualizaTotal = (vldesc: number) => {
    let vltot = 0;
    for (let i = 0; i < _pro.length; i++) {
      vltot = vltot + _pro[i].quantidade * _pro[i].preco;
    }
    vltot = vltot - vldesc;
    setvltotal(vltot);
    return vltot;
  };
  const chegedesconto = (e: any, tp: string) => {
    if (e.target.value !== "") {
      let vlto = AtualizaTotal(0);
      if (tp === "P") {
        setPdesconto(e.target.value);
        if (vlto > 0) {
          setvltotal(vlto - (vlto * e.target.value) / 100);
          setVldesconto((vlto * e.target.value) / 100);
        }
      } else if (tp === "V") {
        setVldesconto(e.target.value);
        if (vlto > 0) {
          setvltotal(vlto - e.target.value);
          setPdesconto((e.target.value / vlto) * 100);
        }
      }
    }
  };
  const cheboxcondpag = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
    setIsDisabled(!e.target.checked);
  };
  return (
    <>
      <Navbar />
      <Container>
        <Form>
          <div>
            <Form.Group className="">
              <Form.Label>
                Consultor: {vendedor} - {user.name}
              </Form.Label>
            </Form.Group>
          </div>
          <div>
            <span className="d-flex justify-content-center fs-3 text-primary">
              Orçamento {orcamento}
            </span>
          </div>
          <div className="row celular">
            <div>
              <input
                className="mt-2 w-75"
                value={consultacliente}
                onChange={(e) => {
                  upcliente(e);
                }}
                placeholder="Digite o CPF ou CNPJ"
              ></input>
              <button
                className="btn btn-info btn-sm mb-1"
                type="button"
                onClick={() => Apigetcliente(1)}
              >
                Buscar
              </button>
              <button
                className="btn btn-info btn-sm mb-1"
                type="button"
                onClick={() => setShowBuscaclientes(true)}
              >
                Pesquisar
              </button>
            </div>
            <Form.Group className="col-8 form-cel">
              <p className="m-0">
                {codigo} - {loja} - {nome} - CGC: {cgc}
              </p>
            </Form.Group>
          </div>
          <div className="row celular">
            <Form.Group className="mb-1 me-4 col-2">
              <Form.Label>Placa</Form.Label>
              <input
                type="text"
                id="placa"
                name="placa"
                className="input-cel"
                value={placa}
                onChange={(e) => {
                  handlingplaca(e);
                }}
                onBlur={getplaca}
                placeholder="Digite a placa"
              />
            </Form.Group>
            <Form.Group className="col-1 form-cel">
              <Button
                className="btn btn-info btn-sm"
                variant="success"
                onClick={getplaca}
              >
                Buscar
              </Button>
            </Form.Group>
            <Form.Group className="col-8 form-cel">
              <p className="m-0">{infoveiculo} </p>
            </Form.Group>
          </div>
          <div className="row celular">
            <Form.Group className="me-4 col-2">
              <Form.Label>Prisma</Form.Label>
            </Form.Group>
            <Form.Group className="">
              <Form.Label className="me-2">Mecanico</Form.Label>
              <select onChange={(e) => chageselectmecanico(e)}>
                {p1.map((i: any, k: any) => (
                  <option key={k} value={"P1" + i}>
                    {addZeroes(i, 3)}
                  </option>
                ))}
              </select>
              <Form.Label className="me-2 ms-4">
                Alinhamento/Balanceamento
              </Form.Label>
              <select onChange={(e) => chageselectalinhamento(e)}>
                {p2.map((i: any, k: any) => (
                  <option key={k} value={"P2" + i}>
                    {addZeroes(i, 3)}
                  </option>
                ))}
              </select>
            </Form.Group>
          </div>
          <div className="row celular">
            <Form.Group className="me-4 col-2">
              <Form.Label>Prisma</Form.Label>
            </Form.Group>
            <Form.Group className="">
              <Form.Label className="me-2">Forma Pagamento</Form.Label>
              <select onChange={(e) => chageselectaformpag(e)}>
                <option value={formapag}>{formapag}</option>
                <option value={"R$"}>DINHEIRO (REAL)</option>
                <option value={"PX"}>PIX</option>
                <option value={"CC"}>CARTAO DE CREDITO</option>
                <option value={"CD"}>CARTAO DE DEBITO AUTOMATICO</option>
                <option value={"CB"}>COBRANCA BANCARIA</option>
                <option value={"CH"}>Cheque</option>
                <option value={"DP"}>Duplicata</option>
              </select>
            </Form.Group>
            <Form.Group className="mt-2">
              <input
                className="me-2"
                type="checkbox"
                onChange={(e) => {
                  cheboxcondpag(e);
                }}
              />
              <Form.Label className="me-2">Condição de pagamento</Form.Label>
              <select
                name="condpagselect"
                onChange={(e) => chageselectcondpag(e)}
                disabled={isDisabled}
              >
                <option key={99} value={codcond}>
                  {codcond} - atual
                </option>
                {condpag.map((item: any, index: any) => (
                  <option key={index} value={item.codigo}>
                    {item.descri} - {item.cond}
                  </option>
                ))}
              </select>
            </Form.Group>
          </div>
          <div className="row celular">
            <Form.Group>
              <Form.Label className="me-2">Observações</Form.Label>
              <input
                type="text"
                className="w-100"
                value={obs}
                onChange={(obs) => changeobs(obs)}
              />
            </Form.Group>
          </div>
          <Row>
            <Col className="mt-lg-3 mt-sm-3">
              <Tabs
                defaultActiveKey="latest"
                transition={false}
                id="collum-3"
                className="mb-3"
                justify
              >
                <Tab eventKey="latest" title="Produtos">
                  <Table striped borderless hover responsive>
                    <tbody>
                      <tr className="fw-bold">
                        <td>Produto</td>
                        <td>Descrição</td>
                        <td>Quantidade</td>
                        <td>preço</td>
                        <td>prço prazo</td>
                        <td>Excluir</td>
                      </tr>
                      {_pro.map((iten: any, i: any) => (
                        <tr key={i} id={i} className={i}>
                          <td>{iten.produto}</td>
                          <td>{iten.prodescricao}</td>
                          <td className="fw-bold">
                            <input
                              className="w-50"
                              type="number"
                              value={iten.quantidade}
                              onChange={(e) => {
                                changeItems(e, i);
                              }}
                              placeholder="Quantidade"
                              required
                            />
                          </td>
                          {/* <td>{Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(iten.pco_venda)}</td> */}
                          <td>
                            <select onChange={(e) => chageselectpreco(e, i)}>
                              <option key={1} value={iten.preco}>
                                {Intl.NumberFormat("pt-br", {
                                  minimumFractionDigits: 2,
                                }).format(iten.preco)}
                              </option>
                              <option key={2} value={iten.pco_venda}>
                                Pco Venda{" "}
                                {Intl.NumberFormat("pt-br", {
                                  minimumFractionDigits: 2,
                                }).format(iten.pco_venda)}
                              </option>
                              <option key={3} value={iten.pco_avista}>
                                Pco Avista{" "}
                                {Intl.NumberFormat("pt-br", {
                                  minimumFractionDigits: 2,
                                }).format(iten.pco_avista)}
                              </option>
                              <option key={4} value={iten.promocao}>
                                Promocao{" "}
                                {Intl.NumberFormat("pt-br", {
                                  minimumFractionDigits: 2,
                                }).format(iten.promocao)}
                              </option>
                            </select>
                          </td>
                          <td>
                            <Button
                              className=""
                              size="sm"
                              variant="outline-success "
                              onClick={(e) => {
                                handlinprcprazo(e, i, iten.produto);
                              }}
                            >
                              <BsCashCoin />
                            </Button>
                          </td>
                          <td>
                            <div>
                              <Button
                                size="sm"
                                variant="outline-danger "
                                onClick={(e) => {
                                  handlingexcluir(e, i);
                                }}
                              >
                                <HiOutlineXMark />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Tab>
              </Tabs>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className="btn btn-primary"
                variant="success"
                onClick={() => setShowmodal(true)}
              >
                Inclui
              </Button>
            </Col>
          </Row>
          <Row>
            <div id="divmodal" className="modal show">
              <Modal show={showmodal} onHide={() => modalclose()}>
                <Modal.Header closeButton>
                  <Modal.Title>Produtos</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row className="">
                    <CacheProvider value={muiCache}>
                      <ThemeProvider theme={createTheme()}>
                        <Row>
                          {/* <Col className="label-buscaproduto"><label>Busca produtos: </label></Col>
                                                    <Col><input className="mb-3 mt-2 w-100" value={buscaprod} onChange={(e) => {uppprod(e)}} onBlur={(e) => {getbusca(e)}}></input></Col> */}
                          <div className="input-group mb-3">
                            <input
                              type="text"
                              value={buscaprod}
                              onChange={(e) => {
                                uppprod(e);
                              }}
                              className="form-control"
                              placeholder="Busca produtos"
                              aria-label="Recipient's username"
                              aria-describedby="button-addon2"
                            />
                            <div className="input-group-append">
                              <button
                                className="btn btn-secondary"
                                type="button"
                                onClick={() => getbusca(buscaprod)}
                              >
                                Buscar
                              </button>
                            </div>
                          </div>
                        </Row>
                        <Row className="mb-2">
                          <Col className="">
                            <select
                              onChange={(e) => chageselectestoque(e)}
                              className="custom-select mr-sm-2"
                              id="inlineFormCustomSelect"
                            >
                              <option value="3">Ambos</option>
                              <option value="1">Estoque Maior que 0</option>
                              <option value="2">Estoque igual a zero</option>
                            </select>
                          </Col>
                        </Row>
                        <MUIDataTable
                          title={""}
                          data={data}
                          columns={columns}
                          options={options}
                        />
                      </ThemeProvider>
                    </CacheProvider>
                  </Row>
                  <Row className="mt-4">
                    <Button
                      className=" ms-3 w-25 btn btn-primary"
                      variant="success"
                      onClick={() => handlingincluir()}
                    >
                      Incluir
                    </Button>
                  </Row>
                </Modal.Body>
              </Modal>
            </div>
          </Row>
          <Row>
            <Col>
              <div>
                <Form.Group className="mb-1 me-4 col-2">
                  <Form.Label>Percentual</Form.Label>
                  <input
                    type="number"
                    id="pdesconto"
                    name="pdesconto"
                    className="input-cel"
                    onChange={(e) => {
                      chegedesconto(e, "P");
                    }}
                  />
                  <p>{pdesconto}%</p>
                </Form.Group>
              </div>
            </Col>
            <Col>
              <div>
                <Form.Group className="mb-1 me-4 col-2">
                  <Form.Label>Valor</Form.Label>
                  <input
                    type="number"
                    id="vldesconto"
                    name="vldesconto"
                    className="input-cel"
                    onChange={(e) => {
                      chegedesconto(e, "V");
                    }}
                  />
                  <p>{vldesconto} R$</p>
                </Form.Group>
              </div>
            </Col>
            <Col>
              <div>
                <Form.Group className="mb-1 me-4 col-2">
                  <Form.Label>Total</Form.Label>
                  <input
                    type="number"
                    id="vltotal"
                    name="vltotal"
                    className="input-cel"
                    value={vltotal}
                    disabled
                  />
                </Form.Group>
              </div>
            </Col>
          </Row>
          <div className="mt-4 d-flex justify-content-start ">
            <Button
              variant="primary"
              onClick={() => (setShowLoading(true), geraorcamento())}
            >
              Grava Orçamento
            </Button>
          </div>
          <div id="divprcprazo" className="modalprcprazo">
            <Modal show={ShowPrcprazo} onHide={() => setShowPrcprazo(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Preços por prazo</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className="mb-2">
                  <Table
                    striped
                    bordered
                    hover
                    variant="light"
                    responsive
                    className="tabela"
                  >
                    <thead>
                      <tr className="col-title">
                        <th>Codigo</th>
                        <th>Condição</th>
                        <th>Preço</th>
                      </tr>
                    </thead>
                    <tbody>
                      {precoprazo.map((list: any) => (
                        <tr key={list.id}>
                          <td>{list.codigo}</td>
                          <td>{list.descricao}</td>
                          <td onClick={() => selectprecoprazo(list.preco)}>
                            {Intl.NumberFormat("pt-br", {
                              minimumFractionDigits: 2,
                            }).format(list.preco)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Row>
              </Modal.Body>
            </Modal>
          </div>
          {/* busca clientes  */}
          <div id="divclientes" className="modalprcprazo">
            <Modal
              show={ShowBuscaclientes}
              onHide={() => setShowBuscaclientes(false)}
            >
              <Modal.Header closeButton>
                <Modal.Title>Busca clientes</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className="mb-2">
                  <div>
                    <input
                      className="mt-2 w-75"
                      value={consultacliente}
                      onChange={(e) => {
                        upcliente(e);
                      }}
                      placeholder="Digite o nome ou razão social"
                    ></input>
                    <button
                      className="btn btn-info btn-sm mb-1"
                      type="button"
                      onClick={() => Apigetcliente(2)}
                    >
                      Buscar
                    </button>
                  </div>
                </Row>
                <Row className="mb-2">
                  <Table
                    striped
                    bordered
                    hover
                    variant="light"
                    responsive
                    className="tabela"
                  >
                    <thead>
                      <tr className="col-title">
                        <th>Codigo</th>
                        <th>Loja</th>
                        <th>Nome ou razaão social</th>
                        <th>Cgc</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clientes.map((list: any) => (
                        <tr key={list.id}>
                          <td>{list.codigo}</td>
                          <td>{list.loja}</td>
                          <td>{list.nome}</td>
                          <td
                            onClick={() =>
                              getBuscacliente(
                                list.cgc,
                                list.codigo,
                                list.loja,
                                list.nome
                              )
                            }
                          >
                            {list.cgc}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Row>
              </Modal.Body>
            </Modal>
          </div>
          <Spinner isLoading={ShowLoading} />
        </Form>
      </Container>
    </>
  );
};

function addZeroes(num: number, len: number) {
  var numberWithZeroes = String(num);
  var counter = numberWithZeroes.length;
  while (counter < len) {
    numberWithZeroes = "0" + numberWithZeroes;
    counter++;
  }

  return numberWithZeroes;
}
export default Editarentrada;
